module.exports = __webpack_public_path__ + "static/media/js-beginner.8d151bd1.png";